import type { SVGProps } from 'react';
const SvgSettingsEthernet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#settings_ethernet_svg__a)">
      <path
        fill="currentColor"
        d="M7.77 6.76 6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24ZM7 13h2v-2H7v2Zm10-2h-2v2h2v-2Zm-6 2h2v-2h-2v2Zm6.77-7.52-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52Z"
      />
    </g>
    <defs>
      <clipPath id="settings_ethernet_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSettingsEthernet;
